import { render, staticRenderFns } from "./SettingPlace.vue?vue&type=template&id=3de7bf7b&scoped=true&"
import script from "./SettingPlace.vue?vue&type=script&lang=js&"
export * from "./SettingPlace.vue?vue&type=script&lang=js&"
import style0 from "./SettingPlace.vue?vue&type=style&index=0&id=3de7bf7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de7bf7b",
  null
  
)

export default component.exports